import axios from 'axios';
import router from "../router"
import { Toast, Indicator } from "mint-ui";
import params from "../service/params"
//请求超时时限
axios.defaults.timeout = 20000;

//请求次数
axios.defaults.retry = 2;
//请求的间隙
axios.defaults.retryDelay = 1000;
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  return config
}, function (error) {

  return Promise.reject(error)
});
// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.data) {
      if (response.data.Code == 0) {
        return response.data.Data;
      } else if (response.data.Code == 100) {
        let ReUrl=encodeURIComponent(window.location.href);
        window.location.href=params.BASE_URL+`?ReUrl=${ReUrl}&RegType=1`;
        return;
      }else if(response.data.Code==1){
          if(response.data.Data){}
          else{
        Toast({
          message: response.data.Message,
          position: "bottom"
        })
      }
      return Promise.reject(response.data);
    }
  }
    return response;
  },
  //响应失败
  error => {
    Indicator.close()
    //请求超时的之后，抛出 error.code = ECONNABORTED的错误..错误信息是 timeout of  xxx ms exceeded
    if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {

      Toast({
        message: '网络超时，请稍后重试！',
        position: 'bottom'
      })
      // var config = error.config;
      // console.log(error.config)
      // config.__retryCount = config.__retryCount || 0;
      // if (config.__retryCount >= config.retry) {
      //   Toast({
      //     message:'网络超时，请稍后重试！',
      //     position:'center'
      //   })
      //   return Promise.reject(error);
      // }
      // config.__retryCount += 1;
      // var backoff = new Promise(function (resolve) {
      //   setTimeout(function () {
      //    console.log('resolve');
      //     resolve();
      //   }, config.retryDelay || 1);
      // });

      // return backoff.then(function () {
      //   return axios(config);
      // });
    } else {
      Toast({
        message: '网络开了点小差～',
        position: "bottom",
      })
      return Promise.reject(error.response);

    }
  });



// WEBPACK FOOTER //
// ./src/service/config.js